import React from 'react'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Checkbox from '@mui/material/Checkbox'
import EcommerceLanguageFields from './EcommerceLanguageFields'

function FormGuida({ handleChange, values, errors, touched, setFieldValue, isModifica }) {
  return (
    <React.Fragment>
      <div className={isModifica ? 'admin-container-lungo' : 'admin-container'}>
        <Stack direction="row" spacing={15}>
          <FormControlLabel
            control={
              <Checkbox
                size="medium"
                color="primary"
                name="attiva"
                value="attiva"
                checked={values.attiva}
                onChange={handleChange}
              />
            }
            label="Attiva"
          />
        </Stack>
        <Stack direction="row" spacing={7} paddingTop={3}>
          <TextField
            id="outlined-basic"
            label="Latitudine"
            variant="outlined"
            name="latitudine"
            onChange={handleChange}
            value={values.latitudine}
            error={touched.latitudine && Boolean(errors.latitudine)}
            helperText={touched.latitudine && errors.latitudine}
            size={'small'}
            fullWidth
            autoComplete="off"
          />
          <TextField
            id="outlined-basic"
            label="Longitudine"
            variant="outlined"
            name="longitudine"
            onChange={handleChange}
            value={values.longitudine}
            error={touched.longitudine && Boolean(errors.longitudine)}
            helperText={touched.longitudine && errors.longitudine}
            size={'small'}
            fullWidth
            autoComplete="off"
          />
        </Stack>
      </div>

      <div className={isModifica ? 'admin-container-lungo' : 'admin-container'}>
        <FormControlLabel
          control={
            <Switch
              size="medium"
              color="primary"
              name="is_ecommerce"
              checked={values.is_ecommerce}
              onChange={handleChange}
            />
          }
          label="Ecommerce"
        />
        {values.is_ecommerce == true && (
          <EcommerceLanguageFields
            handleChange={handleChange}
            values={values}
            errors={errors}
            touched={touched}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default FormGuida
